export default __webpack_public_path__ + "static/media/040_tunnel.092ab4f4.mp4";